interface DeltaCalculation {
  newColumn: string;
  columns: [string, string];
}

const DELTA_CALCULATIONS: DeltaCalculation[] = [
  {
    newColumn: "DELTA_COMP",
    columns: ["Compressor outlet", "Compressor inlet"]
  },
  {
    newColumn: "DELTA_COIL",
    columns: ["Vapor liquid coil outlet", "Vapor liquid coil"]
  },
  {
    newColumn: "DELTA_COOLING",
    columns: ["Compressor inlet", "Vapor liquid coil outlet"]
  },
  {
    newColumn: "DELTA_AMBIENT_OFFSET",
    columns: ["Ambient", "Compressor inlet"]
  }
];

export function calculateDeltaTemperatures(data: Record<string, number[]>): Record<string, number[]> {
  console.log('Delta calculations input data keys:', Object.keys(data));
  const result = { ...data };

  // Create a case-insensitive lookup map
  const dataKeys = Object.keys(data);
  const keyMap = new Map(dataKeys.map(key => [key.toLowerCase(), key]));

  for (const { newColumn, columns: [col1, col2] } of DELTA_CALCULATIONS) {
    console.log(`Checking delta calculation for ${newColumn}: ${col1} - ${col2}`);
    
    // Find the actual keys in the data using case-insensitive matching
    const actualCol1 = keyMap.get(col1.toLowerCase());
    const actualCol2 = keyMap.get(col2.toLowerCase());
    
    console.log(`Column ${col1} exists:`, !!actualCol1);
    console.log(`Column ${col2} exists:`, !!actualCol2);
    
    if (actualCol1 && actualCol2) {
      result[newColumn] = data[actualCol1].map((val1, i) => val1 - data[actualCol2][i]);
      console.log(`Calculated ${newColumn} = ${actualCol1} - ${actualCol2}`);
    } else {
      const missing = [col1, col2].filter(col => !keyMap.has(col.toLowerCase()));
      console.log(`Skipping ${newColumn}: Missing columns ${missing.join(', ')}`);
    }
  }

  console.log('Final delta calculation result keys:', Object.keys(result).filter(key => key.startsWith('DELTA_')));
  return result;
}

export { DELTA_CALCULATIONS }; 